import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Navbar from '../Component/Navbar'
import axiosInstance from '../Api/axiosInstance'

const initialForm = {
    remark: '',
    name: '',
    address: '',
    mobile: '',
    city: '',
    state: '',
    country: '',
    latitude: '',
    longitude: '',
}

const STATES = [
    'Maharashtra', 'Delhi', 'Karnataka', 'Tamil Nadu', 'Telangana',
    'Gujarat', 'Rajasthan', 'Uttar Pradesh', 'West Bengal', 'Punjab',
    'Madhya Pradesh', 'Bihar', 'Odisha', 'Assam', 'Kerala'
]

const COUNTRIES = [
    'India', 'United States', 'United Kingdom', 'Canada', 'Australia',
    'Germany', 'France', 'UAE', 'Singapore', 'Japan'
]

const enterpriseData = JSON.parse(localStorage.getItem("enterpriseData") || "{}")
const ENTERPRISE_ID = enterpriseData._id
const COMPANY_CODE = enterpriseData.companyCode
const API_BASE = 'https://api.imtransporter.com'

const OL = '#6b7c3e'
const OL_LIGHT = '#8a9e52'
const OL_PALE = '#f0f4e8'
const OL_DARK = '#3d4a22'

const navItems = [
    { label: 'Dashboard', icon: '📊', path: '/dashboard' },
    { label: 'Trip Details', icon: '🚚', path: '/trip-details' },
    { label: 'Saved Address', icon: '📍', path: '/save-address' },
    { label: 'Employee Details', icon: '👤', path: '/employee-request' },
    { label: 'Branch Details', icon: '🏢', path: '/branch-details' },
    { label: 'Account', icon: '📋', path: '/account' },
]

const SaveAddress = () => {
    const navigate = useNavigate()
    const [activeNav, setActiveNav] = useState('Saved Address')
    const [addresses, setAddresses] = useState([])
    const [showModal, setShowModal] = useState(false)
    const [form, setForm] = useState(initialForm)
    const [loading, setLoading] = useState(false)
    const [listLoading, setListLoading] = useState(false)
    const [error, setError] = useState('')

    // ── Fetch addresses on page load ──
    useEffect(() => {
        const fetchAddresses = async () => {
            setListLoading(true)
            try {
                const res = await axiosInstance.get(
                    `/enterprise/admin/locations/get`,
                    {
                        params: { companyCode: COMPANY_CODE },
                        useAuth: true,
                    }
                )
                setAddresses(res.data?.data || res.data || [])
            } catch (err) {
                console.error('Failed to fetch addresses:', err)
            } finally {
                setListLoading(false)
            }
        }

        fetchAddresses()
    }, [])

    const handleChange = (e) => {
        setError('')
        setForm({ ...form, [e.target.name]: e.target.value })
    }

    const handleSave = async () => {
        const required = ['remark', 'name', 'address', 'mobile', 'city', 'state', 'country']
        if (required.some((k) => !form[k].trim())) {
            setError('Please fill all required fields.')
            return
        }

        const payload = {
            contactName: form.name,
            contactPhone: Number(form.mobile),
            remark: form.remark,
            phoneNumber: Number(form.mobile),
            latitude: form.latitude ? Number(form.latitude) : 0,
            longitude: form.longitude ? Number(form.longitude) : 0,
            address: form.address,
            city: form.city,
            state: form.state,
            country: form.country,
            enterpriseId: ENTERPRISE_ID,
        }

        setLoading(true)
        setError('')

        try {
            const res = await axiosInstance.post(
                `/enterprise/admin/locations/add`,
                payload,
                { useAuth: true }
            )

            // Push API-shaped object so table fields match
            setAddresses(prev => [...prev, {
                remark: form.remark,
                address: form.address,
                contactName: form.name,
                contactPhone: form.mobile,
                city: form.city,
                state: form.state,
                country: form.country,
            }])
            setForm(initialForm)
            setShowModal(false)
        } catch (err) {
            const message = err?.response?.data?.message || err.message || 'Failed to save address. Please try again.'
            setError(message)
        } finally {
            setLoading(false)
        }
    }

    const handleDelete = (i) => setAddresses(addresses.filter((_, idx) => idx !== i))

    const handleCloseModal = () => {
        if (!loading) {
            setShowModal(false)
            setError('')
            setForm(initialForm)
        }
    }

    return (
        <>
            <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        body { font-family: 'DM Sans', sans-serif; }
        .sa-nav-btn:hover { background: ${OL_PALE} !important; color: ${OL_DARK} !important; }
        .sa-row:hover td { background: #f4f7f0 !important; }
        .sa-add-btn:hover { background: ${OL_LIGHT} !important; }
        .sa-action-btn:hover { background: ${OL_PALE} !important; }
        .sa-del-btn:hover { background: #fee2e2 !important; }
        .sa-cancel-btn:hover { background: #f3f4f6 !important; }
        .sa-input:focus {
          border-color: ${OL} !important;
          box-shadow: 0 0 0 3px rgba(107,124,62,0.12) !important;
          background: #fff !important;
          outline: none;
        }
        .sa-save-btn:hover:not(:disabled) { background: ${OL_LIGHT} !important; }
        .sa-save-btn:disabled { opacity: 0.65; cursor: not-allowed; }
        .sa-spinner {
          display: inline-block;
          width: 14px; height: 14px;
          border: 2px solid rgba(255,255,255,0.4);
          border-top-color: #fff;
          border-radius: 50%;
          animation: spin 0.7s linear infinite;
          margin-right: 6px;
          vertical-align: middle;
        }
        .sa-list-spinner {
          display: inline-block;
          width: 22px; height: 22px;
          border: 3px solid rgba(107,124,62,0.2);
          border-top-color: ${OL};
          border-radius: 50%;
          animation: spin 0.7s linear infinite;
        }
        @keyframes spin { to { transform: rotate(360deg); } }
      `}</style>

            <Navbar />
            <div style={S.shell}>

                {/* ── Sidebar ── */}
                <aside style={S.sidebar}>
                    <div style={S.sidebarLogo}>
                        <span style={S.logoIcon}>🚛</span>
                        <span style={S.logoText}>Menu</span>
                    </div>
                    <nav style={S.nav}>
                        {navItems.map((item) => (
                            <button
                                key={item.label}
                                className="sa-nav-btn"
                                style={{
                                    ...S.navItem,
                                    ...(activeNav === item.label ? S.navItemActive : {}),
                                }}
                                onClick={() => {
                                    setActiveNav(item.label)
                                    navigate(item.path)
                                }}
                            >
                                <span style={S.navIcon}>{item.icon}</span>
                                <span>{item.label}</span>
                                {activeNav === item.label && <span style={S.navIndicator} />}
                            </button>
                        ))}
                    </nav>
                </aside>

                {/* ── Main Content ── */}
                <main style={S.main}>
                    <div style={S.header}>
                        <div>
                            <h1 style={S.title}>Saved Address</h1>
                            <p style={S.subtitle}>Manage your saved delivery addresses</p>
                        </div>
                        <button
                            className="sa-add-btn"
                            style={S.addBtn}
                            onClick={() => setShowModal(true)}
                        >
                            <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                                <path d="M12 5v14M5 12h14" />
                            </svg>
                            Add Address
                        </button>
                    </div>

                    {/* Table */}
                    <div style={S.tableWrapper}>
                        <table style={S.table}>
                            <thead>
                                <tr>
                                    {['Remark', 'Address', 'Contact Name', 'Contact Mobile', 'City', 'State', 'Country'].map((h) => (
                                        <th key={h} style={S.th}>{h}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {listLoading ? (
                                    <tr>
                                        <td colSpan={8} style={S.emptyCell}>
                                            <div style={S.emptyState}>
                                                <span className="sa-list-spinner" />
                                                <p style={{ color: '#888' }}>Loading addresses...</p>
                                            </div>
                                        </td>
                                    </tr>
                                ) : addresses.length === 0 ? (
                                    <tr>
                                        <td colSpan={8} style={S.emptyCell}>
                                            <div style={S.emptyState}>
                                                <span style={{ fontSize: 38 }}>📍</span>
                                                <p>No addresses saved yet</p>
                                            </div>
                                        </td>
                                    </tr>
                                ) : (
                                    addresses.map((a, i) => (
                                        <tr key={i} className="sa-row" style={S.tr}>
                                            <td style={S.td}>
                                                <span style={S.remarkBadge}>{a.remark}</span>
                                            </td>
                                            <td style={{ ...S.td, maxWidth: 180 }}>{a.address}</td>
                                            <td style={{ ...S.td, fontWeight: 600, color: OL_DARK }}>{a.contactName}</td>
                                            <td style={{ ...S.td, letterSpacing: '0.02em' }}>{a.contactPhone}</td>
                                            <td style={S.td}>{a.city}</td>
                                            <td style={S.td}>{a.state}</td>
                                            <td style={S.td}>{a.country}</td>
                                            
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </main>
            </div>

            {/* ── Add Address Modal ── */}
            {showModal && (
                <div
                    style={S.overlay}
                    onClick={(e) => e.target === e.currentTarget && handleCloseModal()}
                >
                    <div style={S.modal}>
                        <div style={S.modalHeader}>
                            <span style={S.modalTitle}>Add New Address</span>
                            <button style={S.closeBtn} onClick={handleCloseModal} disabled={loading}>✕</button>
                        </div>

                        <div style={S.formGrid}>
                            <div style={S.formGroup}>
                                <label style={S.label}>REMARK <span style={S.req}>*</span></label>
                                <input className="sa-input" style={S.input} type="text"
                                    name="remark" value={form.remark} onChange={handleChange}
                                    placeholder="e.g. Home, Office" />
                            </div>

                            <div style={S.formGroup}>
                                <label style={S.label}>CONTACT NAME <span style={S.req}>*</span></label>
                                <input className="sa-input" style={S.input} type="text"
                                    name="name" value={form.name} onChange={handleChange}
                                    placeholder="Full name" />
                            </div>

                            <div style={{ ...S.formGroup, gridColumn: '1 / -1' }}>
                                <label style={S.label}>ADDRESS <span style={S.req}>*</span></label>
                                <input className="sa-input" style={S.input} type="text"
                                    name="address" value={form.address} onChange={handleChange}
                                    placeholder="Street, area, landmark" />
                            </div>

                            <div style={S.formGroup}>
                                <label style={S.label}>CONTACT MOBILE <span style={S.req}>*</span></label>
                                <input className="sa-input" style={S.input} type="tel"
                                    name="mobile" value={form.mobile} onChange={handleChange}
                                    placeholder="+91 XXXXX XXXXX" />
                            </div>

                            <div style={S.formGroup}>
                                <label style={S.label}>CITY <span style={S.req}>*</span></label>
                                <input className="sa-input" style={S.input} type="text"
                                    name="city" value={form.city} onChange={handleChange}
                                    placeholder="City" />
                            </div>

                            <div style={S.formGroup}>
                                <label style={S.label}>STATE <span style={S.req}>*</span></label>
                                <select className="sa-input" style={S.input} name="state" value={form.state} onChange={handleChange}>
                                    <option value="">Select state</option>
                                    {STATES.map((s) => <option key={s}>{s}</option>)}
                                </select>
                            </div>

                            <div style={S.formGroup}>
                                <label style={S.label}>COUNTRY <span style={S.req}>*</span></label>
                                <select className="sa-input" style={S.input} name="country" value={form.country} onChange={handleChange}>
                                    <option value="">Select country</option>
                                    {COUNTRIES.map((c) => <option key={c}>{c}</option>)}
                                </select>
                            </div>

                            <div style={S.formGroup}>
                                <label style={S.label}>LATITUDE <span style={S.opt}>(optional)</span></label>
                                <input className="sa-input" style={S.input} type="number"
                                    name="latitude" value={form.latitude} onChange={handleChange}
                                    placeholder="e.g. 22.009" step="any" />
                            </div>

                            <div style={S.formGroup}>
                                <label style={S.label}>LONGITUDE <span style={S.opt}>(optional)</span></label>
                                <input className="sa-input" style={S.input} type="number"
                                    name="longitude" value={form.longitude} onChange={handleChange}
                                    placeholder="e.g. 72.009" step="any" />
                            </div>
                        </div>

                        {error && (
                            <div style={S.errorBox}>
                                <span>⚠️</span> {error}
                            </div>
                        )}

                        <div style={S.modalActions}>
                            <button className="sa-cancel-btn" style={S.cancelBtn}
                                onClick={handleCloseModal} disabled={loading}>
                                Cancel
                            </button>
                            <button
                                className="sa-save-btn"
                                style={S.saveBtn}
                                onClick={handleSave}
                                disabled={loading}
                            >
                                {loading && <span className="sa-spinner" />}
                                {loading ? 'Saving...' : 'Save Address'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default SaveAddress

// ─── Styles ───────────────────────────────────────────────────────────────────

const S = {
    shell: {
        display: 'flex',
        minHeight: '100vh',
        fontFamily: "'DM Sans', sans-serif",
        background: '#f7f8f4',
        color: '#2c2c2c',
    },
    sidebar: {
        width: 220,
        background: '#fff',
        borderRight: '1px solid #e0e5d4',
        display: 'flex',
        flexDirection: 'column',
        padding: '24px 0',
        flexShrink: 0,
        boxShadow: '2px 0 12px rgba(107,124,62,0.07)',
    },
    sidebarLogo: {
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        padding: '0 20px 24px',
        borderBottom: '1px solid #e8eedd',
        marginBottom: 12,
    },
    logoIcon: { fontSize: 22 },
    logoText: { fontSize: 18, fontWeight: 700, color: '#3d4a22', letterSpacing: '-0.3px' },
    nav: { display: 'flex', flexDirection: 'column', gap: 2, padding: '0 10px' },
    navItem: {
        display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px',
        borderRadius: 10, border: 'none', background: 'transparent', cursor: 'pointer',
        fontSize: 14, fontWeight: 500, color: '#666', textAlign: 'left',
        position: 'relative', transition: 'all 0.18s ease', fontFamily: "'DM Sans', sans-serif",
    },
    navItemActive: { background: '#f0f4e8', color: '#3d4a22', fontWeight: 600 },
    navIcon: { fontSize: 15 },
    navIndicator: {
        position: 'absolute', left: 0, top: '50%', transform: 'translateY(-50%)',
        width: 3, height: 20, borderRadius: '0 3px 3px 0', background: '#6b7c3e',
    },
    main: { flex: 1, padding: '32px 36px', overflow: 'auto' },
    header: {
        display: 'flex', alignItems: 'flex-start',
        justifyContent: 'space-between', marginBottom: 28,
    },
    title: { fontSize: 26, fontWeight: 700, color: '#3d4a22', letterSpacing: '-0.5px' },
    subtitle: { fontSize: 13, color: '#888', marginTop: 3 },
    addBtn: {
        display: 'inline-flex', alignItems: 'center', gap: 7,
        background: '#6b7c3e', color: '#fff', border: 'none', borderRadius: 9,
        padding: '10px 20px', fontSize: 14, fontWeight: 600, cursor: 'pointer',
        fontFamily: "'DM Sans', sans-serif",
        boxShadow: '0 2px 8px rgba(107,124,62,0.22)', transition: 'background 0.15s',
    },
    tableWrapper: {
        background: '#fff', borderRadius: 14, border: '1px solid #e2e8d4',
        overflow: 'hidden', boxShadow: '0 2px 16px rgba(107,124,62,0.07)',
    },
    table: { width: '100%', borderCollapse: 'collapse', fontSize: 14 },
    th: {
        background: '#e8eedd', color: '#3d4a22', fontWeight: 600,
        padding: '13px 16px', textAlign: 'left', fontSize: 13,
        letterSpacing: '0.01em', borderBottom: '2px solid rgba(107,124,62,0.19)',
        whiteSpace: 'nowrap',
    },
    tr: { borderBottom: '1px solid #eef1e8', transition: 'background 0.15s' },
    td: {
        padding: '13px 16px', color: '#3a3a3a', verticalAlign: 'middle',
        background: '#fff', transition: 'background 0.15s',
    },
    remarkBadge: {
        display: 'inline-block', background: '#f0f4e8', color: '#3d4a22',
        borderRadius: 6, padding: '3px 10px', fontSize: 12, fontWeight: 700,
        border: '1px solid rgba(107,124,62,0.19)',
    },
    actionBtn: {
        display: 'inline-flex', alignItems: 'center', gap: 5, padding: '5px 12px',
        borderRadius: 8, border: '1.5px solid rgba(107,124,62,0.38)', background: '#fff',
        color: '#3d4a22', fontWeight: 600, fontSize: 12, cursor: 'pointer',
        fontFamily: "'DM Sans', sans-serif", transition: 'all 0.15s ease',
    },
    emptyCell: { padding: '52px 16px' },
    emptyState: {
        display: 'flex', flexDirection: 'column', alignItems: 'center',
        gap: 10, color: '#aaa', fontSize: 15,
    },
    overlay: {
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.28)',
        backdropFilter: 'blur(2px)', zIndex: 100,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
    },
    modal: {
        background: '#fff', borderRadius: 18,
        boxShadow: '0 8px 48px rgba(0,0,0,0.16)',
        width: 560, maxWidth: '95vw', padding: '32px 32px 28px',
        maxHeight: '90vh', overflowY: 'auto',
    },
    modalHeader: {
        display: 'flex', alignItems: 'center',
        justifyContent: 'space-between', marginBottom: 22,
    },
    modalTitle: { fontSize: '1.1rem', fontWeight: 700, color: '#3d4a22' },
    closeBtn: {
        background: '#f3f4f6', border: 'none', borderRadius: 8,
        width: 32, height: 32, cursor: 'pointer', fontSize: '1rem',
        color: '#4b5563', display: 'flex', alignItems: 'center', justifyContent: 'center',
    },
    formGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px 18px' },
    formGroup: { display: 'flex', flexDirection: 'column', gap: 5 },
    label: { fontSize: '0.75rem', fontWeight: 700, color: '#4b5563', letterSpacing: '0.04em' },
    req: { color: '#dc2626' },
    opt: { color: '#9ca3af', fontWeight: 400, textTransform: 'lowercase', letterSpacing: 0 },
    input: {
        border: '1.5px solid #e0e5d4', borderRadius: 8, padding: '9px 12px',
        fontFamily: "'DM Sans', sans-serif", fontSize: '0.91rem', color: '#1f2937',
        background: '#f0f4e8', transition: 'border 0.13s, box-shadow 0.13s',
        width: '100%',
    },
    errorBox: {
        marginTop: 14, padding: '10px 14px', background: '#fff1f2',
        border: '1.5px solid #fca5a5', borderRadius: 8,
        color: '#b91c1c', fontSize: 13, fontWeight: 500,
        display: 'flex', alignItems: 'center', gap: 8,
    },
    modalActions: {
        display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 22,
    },
    cancelBtn: {
        border: '1.5px solid #e5e7eb', background: '#fff', color: '#4b5563',
        borderRadius: 8, padding: '9px 20px', fontFamily: "'DM Sans', sans-serif",
        fontSize: '0.91rem', fontWeight: 600, cursor: 'pointer', transition: 'background 0.13s',
    },
    saveBtn: {
        background: '#6b7c3e', color: '#fff', border: 'none', borderRadius: 8,
        padding: '9px 22px', fontFamily: "'DM Sans', sans-serif",
        fontSize: '0.91rem', fontWeight: 600, cursor: 'pointer',
        transition: 'background 0.15s', display: 'inline-flex', alignItems: 'center',
    },
}